// base
import React, { Component } from "react";

// components
import { Button, StateButton } from "..";
import { substring, fromNow } from "../../../helper";
import arrow from "../../assets/images/transactions/arrow.png";
import abiDecoder from "abi-decoder";

// assets
import "./ContractTransfers.scss";

const ContractTransfersTable = ({ props }) => {
  const { abi, transactions } = props;

  var txs = transactions;
  if (abi) {
    try {
      abiDecoder.addABI(abi);
      txs = transactions.map((tx) => {
        tx.inputData = abiDecoder.decodeMethod(tx.txt);
        return tx;
      });
    } catch (error) {
      console.warn(error);
    }
  }

  return (
    <div className="responsive_table contract_transfers">
      <table className="table_type01">
        <colgroup>
          <col width="230px" />
          <col width="120px" />
          <col width="200px" />
          <col width="20px" />
          <col width="200px" />
          <col width="160px" />
          <col width="160px" />
          {/* <col width="" /> */}
        </colgroup>
        <thead>
          <tr>
            <th>Tx Hash</th>
            <th>Method</th>

            {/* <th>Age</th> */}

            <th>From</th>
            <th>
              <img src={arrow} alt="에서" />
            </th>
            <th>To</th>
            <th>Value</th>
            <th>Token</th>
            {/* <th>Parameters</th> */}
            <th>Status</th>
          </tr>
        </thead>
        <tbody>
          {txs.map((tx) => (
            <tr key={tx.hash}>
              <td>
                <Button
                  color="blue"
                  link={`/transaction/${tx.hash}`}
                  tooltip={tx.hash}
                >
                  {substring(tx.hash, 10)}
                </Button>
              </td>
              <td>{tx.inputData && tx.inputData.name}</td>
              {/* <td>{fromNow(tx.timestamp)}</td> */}

              <td>
                <Button
                  color="blue"
                  link={`/account/${tx.from}`}
                  tooltip={tx.from}
                >
                  {substring(tx.from)}
                </Button>
              </td>
              <td>
                <img src={arrow} alt="에서" />
              </td>
              <td>
                <Button color="blue" link={`/account/${tx.to}`} tooltip={tx.to}>
                  {substring(tx.to)}
                </Button>
              </td>
              <td>
                {tx.inputData &&
                  tx.inputData.params.map((param, i) => (
                    <div key={i} className="tx_param">
                      {param.type === "uint256"
                        ? parseInt(param.value).toLocaleString()
                        : null}
                    </div>
                  ))}
              </td>
              <td>
                <Button
                  color="blue"
                  size="wide"
                  link={`/contract/${tx.contract}`}
                  tooltip={tx.contract}
                >
                  {tx.contract_name ? tx.contract_name : substring(tx.contract)}
                </Button>
              </td>
              {/* <td>
                {tx.inputData &&
                  tx.inputData.params.map((param, i) => (
                    <div key={i} className="tx_param">
                      <span className="tx_param_name">{param.name} : </span>
                      {param.type === "address" ? (
                        <Button
                          color="blue"
                          link={`/account/${param.value}`}
                          tooltip={param.value}
                        >
                          {substring(param.value)}
                        </Button>
                      ) : param.type === "uint256" ? (
                        parseInt(param.value).toLocaleString()
                      ) : (
                        param.value
                      )}
                    </div>
                  ))}
              </td> */}
              <td>
                <StateButton
                  status={tx.status}
                  reason={tx.reason}
                  style={{ cursor: "default" }}
                />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default ContractTransfersTable;
